const actions = {
  ADD_REQUEST_LINK: 'ADD_REQUEST_LINK',
  ADD_REQUEST_OBJECT: 'ADD_REQUEST_OBJECT',
  APPLY_REQUEST_OBJECTS: 'APPLY_REQUEST_OBJECTS',
  DELETE_ACTIVE_REQUEST_OBJECT: 'DELETE_ACTIVE_REQUEST_OBJECT',
  DELETE_REQUEST_OBJECT: 'DELETE_REQUEST_OBJECT',
  HIDE_REQUEST_OBJECTS: 'HIDE_REQUEST_OBJECTS',
  INSERT_REQUEST_LINK: 'INSERT_REQUEST_LINK',
  INSERT_REQUEST_OBJECT: 'INSERT_REQUEST_OBJECT',
  SHOW_REQUEST_LINKS: 'SHOW_REQUEST_LINKS',
  SHOW_REQUEST_OBJECTS: 'SHOW_REQUEST_OBJECTS',
  UPDATE_ACTIVE_REQUEST_OBJECT: 'UPDATE_ACTIVE_REQUEST_OBJECT',
  UPDATE_REQUEST_FIELDS_OBJECT_PROPERTIES: 'UPDATE_REQUEST_FIELDS_OBJECT_PROPERTIES',
  UPDATE_REQUEST_OBJECT_PROPERTIES: 'UPDATE_REQUEST_OBJECT_PROPERTIES',
  UPDATE_REQUEST_OBJECTS_PROPERTIES: 'UPDATE_REQUEST_OBJECTS_PROPERTIES',
};

export default actions;
